module.exports = __webpack_public_path__ + "img/erik-arbores2.5128dd8b.jpg";